import Vue from 'vue'
import WarningComponent from './warning'
const Component = Vue.extend(WarningComponent)

export default {
	install: VueConstructor => {
		VueConstructor.prototype.$myWarning = function(obj) {
			let component = new Component({
				propsData: obj,
			}).$mount()
			document.body.appendChild(component.$el)
			obj.afterMount && obj.afterMount()
			component.open()
			return new Promise((resolve, reject) => {
				component.$on('confirm', resolve)
				component.$on('cancel', reject)
			}).finally(() => {
				component.$destroy()
				document.body.removeChild(component.$el)
			})
		}
	},
}
